import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { SharedDataService } from "../shared-data.service";
import { Entry, Asset, EntryCollection } from 'contentful';

@Component({
  selector: 'app-program-list',
  templateUrl: './program-list.component.html',
  styleUrls: ['./program-list.component.css']
})
export class ProgramListComponent implements OnInit {

  public programs: Entry<any>[] = [];
  public selectedProgramId: string;
  public objUser: any;
  
  constructor(private router: Router, private contentfulService: ContentfulService, private sharedData: SharedDataService) { }
  
  ngOnInit() {
    this.sharedData.currentMessage.subscribe(message => this.selectedProgramId = message)
    this.contentfulService.getPrograms().then(x => (this.programs = x));
  }

  redirectProgram(codProgram, nameProgram) {

    this.sharedData.currentUser.subscribe(message => this.objUser = message);
    if (this.objUser != null && this.objUser != "")
    {
      this.objUser = JSON.parse(this.objUser);
      if (this.objUser != null) {
        if (this.objUser.lSessionResponse[0].programid.indexOf(codProgram) > -1) {
          this.sharedData.changeProgramId(codProgram);
          sessionStorage.setItem("ProgramId", codProgram);
          this.router.navigate(['/program-detail' + '/' + nameProgram]);
        }
        else {
          console.log("No tiene acceso");
        }
      }
    }
    else {
      this.router.navigate(['/']);
    }
  }

}
